const CAPITAL_MOE_MILESTONES = [
  {
    name: 'Scope',
    description: 'Project scope has been defined and documented.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'construction_manager'],
    sort_order: 1,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'RFP',
    description: 'Request for Proposal has been issued to prospective vendors/contractors.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'construction_manager'],
    sort_order: 2,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Bid and Bid Leveling',
    description: 'Bids have been received and leveled for comparison and selection.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'construction_manager', 'property_manager'],
    sort_order: 3,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Contract',
    description: 'Contract has been executed with the selected contractor.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'construction_manager', 'property_manager'],
    sort_order: 4,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Permit',
    description: 'Building permit has been issued by the Authority Having Jurisdiction.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'construction_manager', 'property_manager'],
    sort_order: 5,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Final Inspections and Commissioning',
    description: "All required final inspections and commissioning by AHJ and/or owner's rep have been completed and passed.",
    responsible_role: 'Construction Manager',
    notify_roles: ['project_manager', 'construction_manager', 'property_manager', 'apm'],
    sort_order: 6,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Lien Releases',
    description: 'Unconditional lien releases have been obtained from the general contractor and all subcontractors.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'property_manager', 'apm'],
    sort_order: 7,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Warranties & As-Builts',
    description: 'All warranties, guarantees, and as-built drawings have been received from the contractor and filed.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'property_manager', 'apm'],
    sort_order: 8,
    status: 'not_started',
    is_standard: true,
  },
];

/* "Approvals Sent to Tenant" used to open this list. It was retired on
   2026-09-28 and is no longer created; tenant projects opened before then still
   have the row, which withoutRetiredMilestones hides rather than deletes.

   "Tenant Sign Permit Received" was dropped on 2026-09-28 too, for a different
   reason: not every tenant has signage, so it is no longer required. It is not
   retired - projects that already have it keep it, and one that needs it adds
   it by hand under the same name, which still gets the Permit Number field
   (PERMIT_MILESTONES in MilestonesTab.jsx). */
const TENANT_MILESTONES = [
  {
    name: 'Preconstruction Meeting Held',
    description: 'Preconstruction meeting has been conducted with Owner, Tenant, GC, and key consultants.',
    responsible_role: 'Construction Manager',
    notify_roles: ['project_manager', 'property_manager', 'apm'],
    sort_order: 1,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Permit Received',
    description: 'Building permit has been officially issued by the Authority Having Jurisdiction.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'property_manager', 'apm', 'tenant'],
    sort_order: 2,
    status: 'not_started',
    is_standard: true,
  },
  {
    name: 'Certificate of Occupancy (CO) Received',
    description: 'Certificate of Occupancy or Temporary CO has been issued by the Authority Having Jurisdiction.',
    responsible_role: 'Project Manager',
    notify_roles: ['project_manager', 'property_manager', 'apm', 'tenant'],
    sort_order: 3,
    status: 'not_started',
    is_standard: true,
  },
];

export async function createStandardMilestones(base44, projectId, projectType) {
  const template = projectType === 'tenant' ? TENANT_MILESTONES : CAPITAL_MOE_MILESTONES;
  const milestones = template.map(m => ({ ...m, project_id: projectId }));
  await base44.entities.Milestone.bulkCreate(milestones);
}

/* Standard milestones that are no longer in a template. Existing rows stay in
   the database but are left out wherever milestones are read, so they neither
   show on the Milestones tab nor count against a project's progress. Only the
   standard one is hidden: a milestone someone added by hand under the same
   name is theirs and stays. */
const RETIRED_STANDARD_MILESTONES = ['Approvals Sent to Tenant'];

export function withoutRetiredMilestones(milestones) {
  return (milestones || []).filter(
    m => !(m.is_standard && RETIRED_STANDARD_MILESTONES.includes(m.name)),
  );
}